<template>
  <div class="inputBox" :style="{ width: width + 'px' }">
    <div class="trigger-box">
      <span class="selectNumBox">
        已选择<span class="num">{{
          selectedCategory.length || 0
        }}</span
        >个
      </span>
      <bi-button type="blueText" :disabled="disabledSelect" @click="handleClick"
        >选择类目</bi-button
      >
    </div>
    <categoryDialog
      :showModal.sync="dialogVisible"
      ref="categoryDialogRef"
      @confirm="handleConfirm"
      :value="selectedCategory"
      :categoryData="categoryOptions"
      :dataType="dataType"
    />
  </div>
</template>

<script>
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";
import categoryDialog from "./categoryDialog.vue";
import { getCategoryList, getCustomCategoryList } from "@/api/bi/category.js";
export default {
  components: {
    categoryDialog,
  },
  name: "categoryCom",
  props: {
    value: {
      type: [String, Array],
      default: "",
    },
    width: {
      type: [Number, String],
      default: "300",
    },
    platformCompanySellerId: {
      type: [String, Number],
      default: "",
    },
    // 1 平台类目 2 店铺类目 3 自定义类目
    dataType: {
      type: [Number, String],
      default: 1,
    },
    initFormData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: "", // 内部存储的值
      selectedCategory: [],
      categoryOptions: [],
      dialogVisible: false,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (!isEqual(newVal, this.internalValue)) {
          this.internalValue = cloneDeep(newVal);
          // 自动判断传入类型，转换为 cascader 需要的数组格式
          if (Array.isArray(newVal)) {
            this.selectedCategory = cloneDeep(newVal);
          } else if (typeof newVal === "string") {
            this.selectedCategory = newVal ? newVal.split(",") : [];
          } else {
            this.selectedCategory = [];
          }
        }
      },
      immediate: true,
      deep: true,
    },
    internalValue: {
      handler(newVal) {
        this.$emit("input", cloneDeep(newVal));
      },
      deep: true,
    },
    platformCompanySellerId: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          if(oldVal != ""){
            this.reset();
          }
          if (newVal) {
            this.getCategoryListFn();
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    disabledSelect() {
      return !this.platformCompanySellerId;
    },
  },
  methods: {
    async getCategoryListFn() {
      if(this.dataType == 3){
        let res = await getCustomCategoryList({
          platformCompanySellerId: this.platformCompanySellerId,
        });
        console.log("--- ~ res:---", res);
        if (res.code == 200 || res.code == 1) {
          this.categoryOptions = this.optionsTree(res?.data || []);
        }
        return;
      } else {
        let res = await getCategoryList({
          platformCompanySellerId: this.platformCompanySellerId,
          type: this.dataType,
        });
        console.log("--- ~ res:---", res);
        if (res.code == 200 || res.code == 1) {
          this.categoryOptions = this.optionsTree(res?.data || []);
        }
      }
    },
    optionsTree(data) {
      let resData = [];
      data.forEach((item) => {
        let pushItem = {
          label: item.name,
          value: item.id,
        };
        if (item.children && item.children.length > 0) {
          pushItem.children = this.optionsTree(item.children);
        }
        resData.push(pushItem);
      });
      return resData;
    },
    reset() {
      // 重置数据，根据当前内部值类型进行重置
      this.selectedCategory = [];
      this.internalValue = Array.isArray(this.internalValue) ? [] : "";
    },
    handleClick() {
      this.dialogVisible = true;
      this.$emit("click");
    },
    handleConfirm(val) {
      this.selectedCategory = cloneDeep(val);
      this.internalValue = Array.isArray(this.value)
        ? cloneDeep(this.selectedCategory)
        : this.selectedCategory.join(",");
      this.$emit("change", cloneDeep(this.internalValue));
    },
  },
};
</script>

<style lang="scss" scoped>
.inputBox {
  .trigger-box {
    height: 30px;
    line-height: 30px;
    padding: 0 4px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    width: 300px;
    background: #fff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdee1;

    &:hover,
    &.is-active {
      border-color: #3159ff;
    }
    .trigger-text {
      font-size: 14px;
      color: #606266;
      width: 234px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .selectNumBox {
      background: #f5f5f5;
      border-radius: 2px 2px 2px 2px;
      height: 22px;
      line-height: 22px;
      padding: 0 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      margin-right: 8px;
      .num {
        color: #ff7f23;
        padding: 0 2px;
      }
    }
  }
}
</style>
